import { NgModule } from '@angular/core'
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr'
import { ToastContainerComponent } from './toast-container.component'
import { ToastComponent } from './toast.component'

@NgModule({
  declarations: [ToastContainerComponent],
  imports: [ToastComponent, ToastrModule.forRoot(), ToastContainerDirective],
  exports: [ToastComponent, ToastContainerComponent, ToastrModule],
})
export class ToastModule {}
